import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { PROCESS } from "../../data/site";

export default function Process() {
  return (
    <section id="processo" data-testid="process-section" className="relative py-28 sm:py-36">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal className="mb-16 max-w-2xl">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-coral">
            / Como trabalhamos
          </span>
          <h2 className="mt-5 font-display font-extrabold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Um processo claro<br />e transparente.
          </h2>
        </Reveal>

        <div className="relative">
          {/* animated vertical/horizontal line */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {PROCESS.map((p, i) => (
              <Reveal
                key={p.n}
                delay={(i % 3) * 0.08}
                data-testid={`process-step-${i}`}
                className="group relative bg-ink p-9 sm:p-11 overflow-hidden"
              >
                <span className="font-display font-extrabold text-white/5 text-8xl absolute -top-4 right-2 select-none group-hover:text-coral/10 transition-colors duration-500">
                  {p.n}
                </span>
                <div className="relative">
                  <span className="font-mono text-coral text-xs tracking-widest">PASSO {p.n}</span>
                  <h3 className="mt-4 font-display font-bold text-white text-2xl">{p.title}</h3>
                  <p className="mt-3 text-muted-fg text-sm leading-relaxed">{p.text}</p>
                </div>
                <motion.span
                  className="absolute bottom-0 left-0 h-0.5 bg-coral"
                  initial={{ width: 0 }}
                  whileInView={{ width: "100%" }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.9, delay: 0.2 + (i % 3) * 0.1 }}
                />
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
